import React, {useEffect, useMemo, useState} from 'react';
import MerchantSettlementList from './merchant_settlement_list';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import {Button, Checkbox, DatePicker, Input, List, Space} from 'antd';
import {CaretDownFilled, SearchOutlined} from '@ant-design/icons';
import serviceHelper from '../../../helpers/functions/service.helper';
import FilterBullet from '../../../helpers/components/filter_bullet';
import dayjs from 'dayjs';
import MerchantSettlementModal from "./settlement_modal";
import merchantSettlementService from "../../../services/ewallet_integration/merchant_settlement.service";
import moment from "moment/moment";
import globalHelper from "../../../helpers/functions/global.helper";

const { RangePicker } = DatePicker;
const MerchantSettlementLayout = ({ default_filter = {}, }) => {
    const { innerWidth } = window;
    const [settlementModal, setSettlementModal] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [merchantSearch, setMerchantSearch] = useState("");
    const [state, setState] = useState({
        loading : false,
        merchants : [],
        all_merchants: [],
    })
    const [filter, setFilter] = useState({
        merchants : default_filter?.merchants,
        start_date : default_filter?.start_date,
        end_date : default_filter?.end_date,
        search : default_filter?.search,
    })
    const [timer, setTimer] = useState(null);

    // submission status list
    const submission_statuses = useMemo(() => {
        return [{
            label : 'In Progress',
            value : 'InProgress',
        },{
            label : 'Valid',
            value : 'Valid',
        },{
            label : 'Partially Valid',
            value : 'PartiallyValid',
        },{
            label : 'Invalid',
            value : 'Invalid',
        }];
    }, [])

    const doneTyping = async (input) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            // setFilter(filter => ({ ...filter, search: input, }));
            changeFilter('search', input);
        }, 300);
        setTimer(newTimer);
    }

    // change date
    const changeDate = (key1, key2, date) => {
    if(date){
        const start_date = dayjs(date[0])?.format("YYYY-MM-DD");
        const end_date = dayjs(date[1])?.format("YYYY-MM-DD");

        // setFilter(filter => ({...filter, [key1] : start_date, [key2] : end_date}));
        changeFilter(key1, start_date);
        changeFilter(key2, end_date);
    }else{
        // setFilter(filter => ({...filter, [key1] : null, [key2] : null}));
        changeFilter(key1, null);
        changeFilter(key2, null);
    }
}

    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = default_filter;
        generate_filter[key] = value;

        setFilter(filter => ({...filter, ...generate_filter, page : 1,}));
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }

    const initialize = async () => {
        setState(state => ({...state, loading : true, }));


        const merchantResponse = await merchantSettlementService?.merchants({ has_balance: true });
        const { merchants, } = merchantResponse.data;

        const merchantListingResponse = await merchantSettlementService.merchants();
        const { merchants: all_merchants, } = merchantListingResponse.data;

        setState(state => ({...state, loading : false, merchants: merchants, all_merchants: all_merchants }));
    }

    const exportExcel = async () => {
        setExportLoading(true);
        const { search, status, merchants, start_date, end_date, } = filter;
        const response = await merchantSettlementService?.merchantSettlementListing({
            // filter
            search,
            // status,
            merchant_ids : merchants,
            start_date : start_date,
            end_date : end_date,

            is_export: true,
            // order
            order : "created_at",
            order_position : 'DESC',
        });

        const { rows } = response?.data;

        const data = rows?.map((obj, index) => {
            const { merchant, activity, created_at } = obj ?? {};
            const count = (index + 1);
            return {
                "No" : count,
                "Merchant" : merchant?.name,
                "Transaction No." : activity?.transaction_no,
                "Status" :  activity?.activity_status?.name,
                "Date" : moment(created_at)?.isValid() ? moment(created_at)?.format("DD MMM YYYY HH:mm") : "",
                "Amount" : activity?.melon_amount,
            }
        });
        globalHelper.exportToExcel({
            data : data,
            name : `merchant_settlements_${moment()?.format("YYYYMMDD")}`,
        });

        setExportLoading(false);
        // setState(state => ({...state, generate_loading : false, }));
    }

    useEffect(() => {
        initialize();
    }, [])

    return (
        <>
            <div className='mobile-padding-12'>
                <div style={{marginBottom: 24, textAlign:'start'}}>
                    <PageHeaderComponent title={'Merchant Settlements'} />
                </div>

                <div>
                    <Input
                    onChange={(e) => doneTyping(e.target.value)}
                    name="search"
                    defaultValue={filter?.search}
                    prefix={<SearchOutlined style={{color :'var(--secondary-text-color)'}} />}
                    placeholder='Search'
                    style={{minWidth: '100%',}}
                    allowClear
                    // {...(errors?.find(x => x?.type === 'search_length') && ({ status : 'warning', }))}
                    />
                    <div style={{display: 'flex', alignItems: 'center', marginTop: 12, gap: 8,}}>
                        <div className='filter-panel' style={{textAlign: 'start'}}>
                            <Space direction={innerWidth > 768 ? 'horizontal' : 'vertical'}>
                                <FilterBullet
                                    popover={
                                        <>
                                            <div>
                                                <Input prefix={<SearchOutlined
                                                    style={{color: 'var(--secondary-text-color)'}}/>}
                                                       value={merchantSearch}
                                                       onChange={(e) => setMerchantSearch(e.target.value)}
                                                       placeholder='Search Merchants'/>
                                            </div>

                                            <Checkbox.Group
                                                value={filter?.merchants}
                                                onChange={(checkedValues) => changeFilter('merchants', checkedValues)}
                                            >
                                                <List
                                                    style={{width: 280,}}
                                                    dataSource={
                                                        (state?.all_merchants || []).filter((m) =>
                                                            m?.name?.toLowerCase().includes(merchantSearch.toLowerCase())
                                                        )
                                                    }
                                                    renderItem={(item, index) => {
                                                        const {merchant_id, name,} = item ?? {};
                                                        return (
                                                            <List.Item style={{width: '100%'}} key={index}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    width: '100%'
                                                                }}>
                                                                    <div>
                                                                        <span>{name}</span>
                                                                    </div>
                                                                    <div style={{marginLeft: 'auto'}}>
                                                                        <Checkbox
                                                                            value={merchant_id}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </List.Item>
                                                        )
                                                    }}
                                                />
                                            </Checkbox.Group>
                                        </>
                                    }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                                <span>Merchant {filter?.merchants?.length > 0 ? `: ${filter?.merchants?.length}` : ''}</span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color: '#a0aec0'}}/>
                                            </div>
                                        </Space>

                                    </div>
                                </FilterBullet>

                                <FilterBullet
                                    popover={
                                        <>
                                            <div>
                                                <RangePicker
                                                    {...(filter?.start_date && filter?.end_date) && ({defaultValue: [dayjs(filter?.start_date), dayjs(filter?.end_date)]})}
                                                    onChange={(e) => changeDate('start_date', 'end_date', e)}
                                                    format={"YYYY-MM-DD"}
                                                />
                                            </div>
                                        </>
                                    }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                                <span>Issue Date
                                                    <span style={{
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        color: 'var(--secondary-text-color)'
                                                    }}>
                                                        {filter?.start_date && filter?.end_date && `: ${filter?.start_date}-${filter?.end_date}`}
                                                    </span>
                                                </span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color: '#a0aec0'}}/>
                                            </div>
                                        </Space>
                                    </div>
                                </FilterBullet>
                            </Space>
                        </div>

                        <div style={{marginLeft: 'auto'}}>
                            <Space>
                                <Button loading={exportLoading} onClick={() => exportExcel()}>
                                    Export
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={() => setSettlementModal(true)}
                                >
                                    Create Settlement
                                </Button>
                            </Space>
                        </div>

                    </div>
                </div>

                <div style={{marginTop: 12,}}>
                    <MerchantSettlementList filter={filter}/>
                </div>
            </div>

            <MerchantSettlementModal
                visible={settlementModal}
                onClose={() => setSettlementModal(false)}
                refresh={initialize}
                // onSubmit={handleSettlement}
                // initialData={selectedSettlement} // null for create
                merchants={state.merchants}
                merchantOptions={state.merchants.map(m => ({ label: m.name, value: m.merchant_id }))}
            />
        </>
    );
}

export default MerchantSettlementLayout;